import { ChevronDown, ChevronUp } from 'lucide-react';

/** Botão "Ver métricas / Ocultar métricas" (mesmo visual de Vendas). */
export default function MetricsToggle({ open, onToggle }) {
    return (
        <button
            type="button"
            onClick={onToggle}
            aria-expanded={open}
            className="inline-flex items-center justify-center gap-2 py-2 px-4 rounded-xl border border-dashed border-white/[0.08] text-white/60 text-sm hover:text-white hover:border-white/20 transition-colors"
        >
            {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            {open ? 'Ocultar métricas' : 'Ver métricas'}
        </button>
    );
}
